<template>
  <div class="need-help">
    <div class="need-help__wrapper">
      <picture
        class="need-help__picture"
        :class="{'need-help__picture--filter': !!moduleData }">
        <source
          media="(-webkit-min-device-pixel-ratio: 2)"
          :srcset="`/images/bg/need_help/need-help-bg@x2.avif`"
          type="image/avif">
        <source
          media="(-webkit-min-device-pixel-ratio: 2)"
          :srcset="`/images/bg/need_help/need-help-bg@x2.jpg`">
        <source
          :srcset="`/images/bg/need_help/need-help-bg.avif`"
          type="image/avif">
        <img
          data-src="/images/bg/need_help/need-help-bg.jpg"
          alt=""
          class="need-help__bg lazyload"
          width="1600"
          height="176">
      </picture>

      <p class="need-help__icon">
        🤜🤛
      </p>

      <div class="need-help__title">
        <span class="need-help__subtitle">Didn’t find what you need?</span> Create a custom order
      </div>

      <div class="need-help__message">
        Contact us and a PRO player will help you out.
        We'll find the best deal or create a personalized order for you at a lower price.
      </div>

      <div
        class="button button-main need-help__button"
        :class="{'button-additional': !!moduleData}"
        @click="openIntercom">
        Create custom order
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import GameModel from 'Models/GameModel';
import googleTagAnalytics from 'Root/drivers/googleTagAnalytics';
import IntercomApiDriver from 'Root/drivers/IntercomApiDriver';

export default {
  name: 'NeedHelp',

  props: {
    productsData: {
      type: Array,
      default: null,
    },

    moduleData: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapState(['activeGame']),

    imageGameId() {
      const availableIds = [
        GameModel.WOW.id,
        GameModel.DESTINY.id,
        GameModel.WOW_BC.id,
        GameModel.COD_MW.id,
        GameModel.NEW_WORLD.id,
      ];

      // Пока нет фонов по новым играм используем как дефолтный от destiny
      return availableIds.includes(this.activeGame.id) ? this.activeGame.id : GameModel.DESTINY.id;
    },
  },

  methods: {
    openIntercom() {
      googleTagAnalytics.emitStartOwnOrder();
      const predefinedMessage = 'Didn\'t find what you were looking for?\n'
        + 'Input here what kind of boost you need and our manager will send you our best offer.';
      IntercomApiDriver.showNewMessage(predefinedMessage);
    },
  },
};
</script>

<style lang="scss" scoped>
  /* Mobile */
  .need-help {
    position: relative;
  }

  .need-help__wrapper {
    display: flex;
    padding: 25px 25px 18px;
    flex-direction: column;
    width: 100%;
    position: relative;
    z-index: 1;
    border-radius: 10px;
    overflow: hidden;
  }

  .need-help__picture {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .need-help__picture--filter {
    filter: saturate(0.4) brightness(0.5) hue-rotate(352deg);
  }

  .need-help__bg {
    position: absolute;
    object-fit: cover;
    object-position: 25% center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 10px;
  }

  .need-help__icon,
  .need-help__title,
  .need-help__message,
  .need-help__button {
    isolation: isolate;
  }

  .need-help__icon {
    display: none;
    font-size: 35px;
    line-height: 1;
    white-space: nowrap;
  }

  .need-help__title {
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    color: $color--basic-white;
    margin-bottom: 18px;
    align-self: center;
  }

  .need-help__message {
    font-weight: 400;
    font-size: 11px;
    color: $color--basic-white;
    margin-bottom: 15px;
    align-self: center;
  }

  .need-help__button {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: none;
    font-size: 13px;
    height: 40px;
    min-width: 160px;
  }

  @media screen and (min-width: 800px) {
    .need-help__wrapper {
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      padding: 40px 25px;
    }

    .need-help__icon {
      display: block;
      margin-right: 10px;
    }

    .need-help__title {
      margin-bottom: 0;
    }

    .need-help__subtitle {
      display: block;
    }

    .need-help__message {
      font-size: 13px;
      max-width: 240px;
      margin: 0 10px;
    }
  }

  @media screen and (min-width: #{1000px + $size-pc-sidebar}) {
    .need-help__wrapper {
      padding: 40px 35px;
      justify-content: center;
    }

    .need-help__icon {
      margin-right: 28px;
    }

    .need-help__title {
      font-size: 24px;
      line-height: 30px;
      margin-right: 28px;
      margin-bottom: 0;
    }

    .need-help__message {
      max-width: 295px;
      font-size: 15px;
      margin: 0 28px 0 0;
    }

    .need-help__button {
      font-size: 15px;
      height: 48px;
      padding: 0 15px;
    }
  }

  @media screen and (min-width: #{1150px + $size-pc-sidebar}) {
    .need-help__title {
      font-size: 25px;
    }

    .need-help__message {
      margin-right: 85px;
    }
  }
</style>
